export default __webpack_public_path__ + "static/media/lead-pollen.4e3245be.png";